import * as React from 'react';

import { Link } from "react-router-dom";
import { useState, useEffect, useCallback, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import axios from "axios";
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import ClearAllTwoToneIcon from '@mui/icons-material/ClearAllTwoTone';
import { Hidden, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Table, TableHead, TableBody, TableRow, TableCell, Paper, Typography, Grid } from '@mui/material';
import { Button, Input, Row, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label } from "reactstrap";
import Menu from './Menu';
import Header from './Header';

import { DataGridPro, GridRowsProp, GridColDef, } from '@mui/x-data-grid-pro';
import type { } from '@mui/x-data-grid/themeAugmentation';


import '@inovua/reactdatagrid-community/index.css'

import moment from 'moment';
import { BounceLoader } from 'react-spinners';
import { Column, ReportObject, renderDate, ReportObjectGrid, ContImproveOBJ, ExpenseOBJ } from "./MagniTypes";
import { CheckBox } from '@mui/icons-material';
import { Checkbox } from '@mui/material';
import APICalls from './APICalls';
import * as ExcelJS from 'exceljs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DataLoading } from './Loading';
//import jsPDF from 'jspdf'
//import 'jspdf-autotable';


var jsPDF = require('jspdf').jsPDF;
require('jspdf-autotable');



window.moment = moment;




function TablePaginationActions(props: any) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event: any) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: any) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: any) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: any) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


export default function ContImprove() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // 768px as breakpoint for mobile
  const [loading, setLoading] = useState(true);
  const [rows, setData] = useState<any[]>([]);
  const [reload, setReload] = useState(false);
  const [CRUsers, setCRUsers] = useState<any[]>([]);

  // Add state for report filter type
  type ReportFilter = "all reports" | "active reports" | "closed reports";
  const defaultFilter: ReportFilter = "active reports";
  const [selectedFilter, setSelectedFilter] = useState<ReportFilter>(
    () => (sessionStorage.getItem('ciReportFilter') as ReportFilter) || defaultFilter
  );

  const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);

  const [users, setUsers] = useState<{ [key: number]: string }>({});

  const apiCalls = new APICalls();

  useEffect(() => {
    setLoading(true);
  
    const loadData = async () => {
      await fetchUsers(); // Fetch users first
      await GetCRUsers(); // Add this to load users for dropdowns
    };
  
    loadData();
  
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
  
      setIsMobile(width <= 768);
      setWindowWidth(width);
      setIsLandscape(width > height);
    };
  
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [reload]);
  
  useEffect(() => {
    if (Object.keys(users).length > 0) {
      try {
        setLoading(true);
        const fetchInitialData = async () => {
          // Apply selected filter type - default to Active reports
          let response;
          
          if (selectedFilter === "active reports") {
            response = await apiCalls.GetActiveCI();
          } else if (selectedFilter === "closed reports") {
            response = await apiCalls.GetClosedCI();
          } else {
            response = await apiCalls.GetAllCI();
          }
          
          const mappedData = mapReportData(response.data);
          setData(mappedData);
          setLoading(false);
        };
        
        fetchInitialData();
      } catch (error) {
        console.error('Error fetching initial data:', error);
        setLoading(false);
      }
    }
  }, [users, selectedFilter]); // Re-fetch when filter changes

  // Function to handle filter changes
  const handleFilterChange = async (newFilter: ReportFilter) => {
    setSelectedFilter(newFilter);
    // Save filter selection to session storage
    sessionStorage.setItem('ciReportFilter', newFilter);

    try {
      setLoading(true);
      let response;
      
      if (newFilter === "active reports") {
        response = await apiCalls.GetActiveCI();
      } else if (newFilter === "closed reports") {
        response = await apiCalls.GetClosedCI();
      } else {
        response = await apiCalls.GetAllCI();
      }
      
      const mappedData = mapReportData(response.data);
      setData(mappedData);
      setLoading(false);
    } catch (error) {
      console.error(`Error fetching ${newFilter}:`, error);
      setLoading(false);
    }
  };

  // Function to fetch user data
  const fetchUsers = async () => {
    try {
      const response = await apiCalls.GetCRUsers();
      const userList = response.data;

      // Convert array into lookup object: { 1: 'John Doe', 2: 'Jane Smith', ... }
      const userMap: { [key: number]: string } = {};
      userList.forEach((user: { userID: number; FullName: string }) => {
        userMap[user.userID] = user.FullName;
      });

      setUsers(userMap);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  // Add function to get CR users for dropdowns
  const GetCRUsers = async () => {
    try {
      const response = await apiCalls.GetCRUsers();
      console.log("CR Users:", response.data);
      setCRUsers(response.data);
    } catch (error) {
      console.error("Error fetching CR users:", error);
    }
  };








  const [windowWidth, setWindowWidth] = useState(window.innerWidth);



  const commonHeaderStyle = {
    backgroundColor: '#d3d3d3',
    color: '#FFFFFF',
  };






  const columns2: GridColDef[] = [
    { field: 'CINumber', headerName: 'CI Number', width: 70, type: 'number' },
    { field: 'CRNumber', headerName: 'CR Number', width: 70, type: 'number' },
    { 
      field: 'ProjName', 
      headerName: 'Project Name', 
      width: 160,
      flex: 0.7,
      type: 'string',
      renderCell: (params) => (
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          whiteSpace: 'normal',
          lineHeight: '1.2',
          padding: '4px',
          overflow: 'visible'
        }}>
          {params.value}
        </div>
      )
    },
    { field: 'Date', headerName: 'Date Created', width: 85, type: 'date' },
 
    { 
      field: 'ProjCoord', 
      headerName: 'Coordinator', 
      width: 100,
      flex: 0.4, 
      type: 'string',
      renderCell: (params) => (
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          whiteSpace: 'normal',
          lineHeight: '1.2',
          padding: '4px',
          overflow: 'visible'
        }}>
          {params.value}
        </div>
      )
    },
    { 
      field: 'ProjTeam', 
      headerName: 'Team', 
      width: 140,
      flex: 0.5, 
      type: 'string',
      renderCell: (params) => (
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          whiteSpace: 'normal',
          lineHeight: '1.2',
          padding: '4px',
          overflow: 'visible'
        }}>
          {params.value}
        </div>
      )
    },
    { 
      field: 'Duration', 
      headerName: 'Duration', 
      width: 80,
      flex: 0.3, 
      type: 'string',
      renderCell: (params) => (
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          whiteSpace: 'normal',
          lineHeight: '1.2',
          padding: '4px',
          overflow: 'visible'
        }}>
          {params.value}
        </div>
      )
    },
    { 
      field: 'Estimated_Completetion_Date', 
      headerName: 'Est. Completion', 
      width: 85,
      flex: 0.3, 
      type: 'date'
    },
    { 
      field: 'StartDate', 
      headerName: 'Start Date', 
      width: 85,
      flex: 0.3, 
      type: 'date'
    },
    { 
      field: 'EndDate', 
      headerName: 'End Date', 
      width: 85,
      flex: 0.3, 
      type: 'date'
    },
    { 
      field: 'Approval1', 
      headerName: 'Approval 1', 
      width: 85,
      flex: 0.3,
      headerAlign: 'center',
      type: 'string',
      renderCell: (params) => (
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          whiteSpace: 'normal',
          lineHeight: '1.2',
          padding: '4px',
          overflow: 'visible'
        }}>
          {params.value}
        </div>
      )
    },
    { 
      field: 'ApprovalDate1', 
      headerName: 'Approval 1 Date', 
      width: 85,
      flex: 0.3, 
      type: 'date'
    },
    { 
      field: 'Approval2', 
      headerName: 'Approval 2', 
      width: 85,
      flex: 0.3,
      headerAlign: 'center',
      type: 'string',
      renderCell: (params) => (
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          whiteSpace: 'normal',
          lineHeight: '1.2',
          padding: '4px',
          overflow: 'visible'
        }}>
          {params.value}
        </div>
      )
    },
    { 
      field: 'ApprovalDate2', 
      headerName: 'Approval 2 Date', 
      width: 85,
      flex: 0.3, 
      type: 'date'
    },
    { 
      field: 'Project_Rejected', 
      headerName: 'Rejected Date', 
      width: 85,
      flex: 0.3, 
      type: 'date'
    }
  ];



 












  





  const navigate = useNavigate();



  // Add new state variables for the modal
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCI, setSelectedCI] = useState<ContImproveOBJ | null>(null);
  const [selectedCIExpenses, setSelectedCIExpenses] = useState<ExpenseOBJ[]>([]);
  const [loadingDetails, setLoadingDetails] = useState(false);

  // Add a new state to track edited CI data
  const [editedCI, setEditedCI] = useState<ContImproveOBJ | null>(null);

  // Add state to track unsaved changes in the edit CI modal
  const [hasUnsavedEditChanges, setHasUnsavedEditChanges] = useState(false);
  
  // Store initial state of the edited form for comparison
  const initialEditCIRef = useRef<any>(null);

  // Function to handle input changes
  const handleInputChange = (field: keyof ContImproveOBJ, value: any) => {
    if (editedCI) {
      // For user fields, we need to convert to number if it's a user ID
      if (field === 'ProjCoord' || field === 'Approval1' || field === 'Approval2') {
        const numValue = value === '' ? null : parseInt(value);
        setEditedCI({
          ...editedCI,
          [field]: numValue
        });
      } else {
        setEditedCI({
          ...editedCI,
          [field]: value
        });
      }
      
      // Check for unsaved changes by comparing with initial state
      if (initialEditCIRef.current) {
        setHasUnsavedEditChanges(true);
      }
    }
  };

  // Function to handle date input changes
  const handleDateChange = (field: keyof ContImproveOBJ, value: string) => {
    if (editedCI) {
      // Convert date string to Date object if not empty
      const dateValue = value ? new Date(value) : null;
      setEditedCI({
        ...editedCI,
        [field]: dateValue
      });
      
      // Check for unsaved changes
      if (initialEditCIRef.current) {
        setHasUnsavedEditChanges(true);
      }
    }
  };

  // Function to fetch CI details including expenses
  const fetchCIDetails = async (ciNumber: number) => {
    try {
      setLoadingDetails(true);
      console.log("Fetching details for CI Number:", ciNumber);
      const response = await apiCalls.GetCIByID(ciNumber);
      console.log("CI Details API Response:", response); // Debug log to check response data
      
      if (response && response.data) {
        // Extract CI data - handle both formats of responses
        let ciData;
        let expensesData = [];
        
        if (response.data.ciDetails) {
          // First format: { ciDetails: {...}, expenses: [...] }
          ciData = response.data.ciDetails;
          expensesData = response.data.expenses || [];
        } else {
          // Second format: { CINumber: ..., Expenses: [...] }
          ciData = response.data;
          // Extract expenses from the Expenses property of the CI data if it exists
          expensesData = response.data.Expenses || [];
        }
        
        console.log("Setting CI data:", ciData);
        console.log("Setting expenses data:", expensesData);
        
        setSelectedCI(ciData);
        // Also set to editedCI for tracking changes
        setEditedCI(ciData);
        // Store the initial state for comparison
        initialEditCIRef.current = JSON.parse(JSON.stringify(ciData));
        // Reset unsaved changes flag
        setHasUnsavedEditChanges(false);
        
        setSelectedCIExpenses(expensesData);
      } else {
        console.error("No data received from API");
      }
      setLoadingDetails(false);
    } catch (error) {
      console.error('Error fetching CI details:', error);
      setLoadingDetails(false);
    }
  };

  // Function to submit changes
  const handleSubmitChanges = async () => {
    if (!editedCI) return;
    
    // Add confirmation dialog
    if (!window.confirm("Are you sure you want to save these changes?")) {
      return; // Exit if user cancels
    }
    
    try {
      console.log("Submitting changes:", editedCI);
      // Show loading state while submitting
      setLoadingDetails(true);
      
      // Call API to update CI record
      const response = await apiCalls.EditCI(editedCI);
      console.log("Edit CI Response:", response);
      
      // Update the selected CI with the edited values
      setSelectedCI(editedCI);
      
      // Reset unsaved changes flag
      setHasUnsavedEditChanges(false);
      // Update the initial reference to current state
      initialEditCIRef.current = JSON.parse(JSON.stringify(editedCI));
      
      // Refresh data to show updated values
      fetchCIDetails(editedCI.CINumber);
      
      toast.success("Changes saved successfully!");
    } catch (error) {
      console.error("Error updating CI:", error);
      toast.error("Error saving changes. Please try again.");
    } finally {
      setLoadingDetails(false);
    }
  };

  // Function to close the modal
  const handleCloseModal = () => {
    // Check if there are unsaved changes
    if (hasUnsavedEditChanges) {
      if (!window.confirm("You have unsaved changes. Are you sure you want to close this form?")) {
        return; // Cancel closing if user says no
      }
    }
    
    setModalOpen(false);
    setSelectedCI(null);
    setEditedCI(null);
    setSelectedCIExpenses([]);
    // Reset unsaved changes state
    setHasUnsavedEditChanges(false);
    initialEditCIRef.current = null;
  };

  // Function to open the modal with the selected CI
  const handleOpenModal = (ci: ContImproveOBJ) => {
    console.log("Selected CI for modal:", ci); // Debug log to verify CI object
    setSelectedCI(ci); // Set the initial CI data immediately for better UX
    setModalOpen(true);
    fetchCIDetails(ci.CINumber);
  };


  

  // Update the onRowDoubleClick function to open the modal instead of navigating
  const onRowDoubleClick = useCallback((params: any) => {
    handleOpenModal(params.row);
  }, []);

  // Replace the existing onRowClick function
  const onRowClick = useCallback((rowProps: any) => {
    // Keeping the same behavior for row clicks, but we'll disable it and use double-click for modal
    if (isMobile) {
      handleOpenModal(rowProps.data);
    }
  }, [isMobile]);

  // Format date for display in the modal
  const formatDate = (dateString: string | null | undefined) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  };

  const onRenderRow = useCallback((rowProps: any) => {
    const { onClick, onDoubleClick, ...restProps } = rowProps;

    const handleDoubleClick = (event: any) => {
      onRowDoubleClick(rowProps);
      if (onDoubleClick) {
        onDoubleClick(event);
      }
    };

    const handleClick = (event: any) => {
      onRowClick(rowProps);
      if (onClick) {
        onClick(event);
      }
    };



    // Assuming that rows are rendered as div elements in the original grid.
    // This might not be correct and you might need to look for the proper way 
    // to render a row if the library does not expose its default row rendering component.
    return <div {...restProps} onClick={isMobile ? handleClick : undefined}
      onDoubleClick={isMobile ? undefined : handleDoubleClick} />;
  }, [onRowClick, onRowDoubleClick, isMobile]);

  // Add new state variables for the create modal
const [createModalOpen, setCreateModalOpen] = useState(false);
const [newCI, setNewCI] = useState<Partial<ContImproveOBJ> & { Expenses: ExpenseOBJ[] }>({
  CRNumber: null,
  ProjName: '',
  Date: null,
  ProjDesc: '',
  ProjCoord: null,
  ProjTeam: '',
  Duration: '',
  Estimated_Completetion_Date: null,
  StartDate: null,
  EndDate: null,
  Approval1: null,
  ApprovalDate1: null,
  Approval2: null,
  ApprovalDate2: null,
  Project_Rejected: null,
  Description_of_Result: '',
  Present_Target_Level_of_Performance: '',
  Monitoring_and_Measurement_Methods: '',
  Project_Tracking: '',
  Expenses: [] // Add this to track expenses locally
});

// Add these state variables for managing expenses in the create modal
const [createExpenseModal, setCreateExpenseModal] = useState(false);
const [createExpenseEditMode, setCreateExpenseEditMode] = useState(false);
const [selectedCreateExpense, setSelectedCreateExpense] = useState<ExpenseOBJ | null>(null);
// Fix the newCreateExpense declaration
const [newCreateExpense, setNewCreateExpense] = useState<ExpenseOBJ>({
  ID: 0,
  CINumber: 0,
  ExpDesc: '',
  EstimatedCost: 0,
  Expense: 0,
  PO: ''
});
const [createExpenseDeleteModal, setCreateExpenseDeleteModal] = useState(false);
const [selectedCreateExpenseForDelete, setSelectedCreateExpenseForDelete] = useState<any>(null);

// Add handler functions for create expense operations
// Function to handle input changes for expense form in create mode
const handleCreateExpenseInputChange = (field: keyof ExpenseOBJ, value: any) => {
  if (createExpenseEditMode && selectedCreateExpense) {
    // Make sure all fields are properly typed
    const updatedExpense: ExpenseOBJ = {
      ...selectedCreateExpense,
      [field]: field === 'EstimatedCost' || field === 'Expense' ? parseFloat(value) || 0 : value
    };
    
    setSelectedCreateExpense(updatedExpense);
  } else {
    // Make sure all fields are properly typed
    setNewCreateExpense({
      ...newCreateExpense,
      [field]: field === 'EstimatedCost' || field === 'Expense' ? parseFloat(value) || 0 : value
    });
  }
  
  // Mark form as having unsaved changes
  setHasUnsavedCreateChanges(true);
};
// Function to handle adding a new expense in create mode
const handleAddCreateExpense = () => {
  setNewCreateExpense({
    ID: 0, // Use timestamp for temporary ID
    CINumber: 0,
    ExpDesc: "",
    EstimatedCost: 0,
    Expense: 0,
    PO: ""
  });
  setCreateExpenseEditMode(false);
  setCreateExpenseModal(true);
};

// Function to handle editing an expense in create mode
const handleEditCreateExpense = (expense: any) => {
  setSelectedCreateExpense({ ...expense });
  setCreateExpenseEditMode(true);
  setCreateExpenseModal(true);
};

// Function to open the delete confirmation modal in create mode
const handleDeleteCreateExpense = (expense: any) => {
  setSelectedCreateExpenseForDelete(expense);
  setCreateExpenseDeleteModal(true);
};

// Function to handle submitting the expense form in create mode
const handleCreateExpenseSubmit = () => {
  try {
    if (createExpenseEditMode && selectedCreateExpense) {
      // Edit an existing expense in the local state
      const updatedExpenses = newCI.Expenses.map((exp: ExpenseOBJ) => 
        exp.ID === selectedCreateExpense.ID ? selectedCreateExpense : exp
      );
      
      // Update newCI.Expenses
      setNewCI((prev: any) => ({
        ...prev,
        Expenses: updatedExpenses
      }));
      
      // Also update the redundant newCIExpenses array to keep them in sync
      setNewCIExpenses(updatedExpenses);
    } else {
      // Add a new expense to the local state
      const expenseToAdd: ExpenseOBJ = {
        ID: newCreateExpense.ID || 0, // Ensure there's an ID
        CINumber: 0,
        ExpDesc: newCreateExpense.ExpDesc,
        EstimatedCost: newCreateExpense.EstimatedCost,
        Expense: newCreateExpense.Expense,
        PO: newCreateExpense.PO
      };
      
      const updatedExpenses = [...(newCI.Expenses || []), expenseToAdd];
      
      // Update newCI.Expenses
      setNewCI((prev: any) => ({
        ...prev,
        Expenses: updatedExpenses
      }));
      
      // Also update the redundant newCIExpenses array to keep them in sync
      setNewCIExpenses(updatedExpenses);
    }
    
    // Mark form as having unsaved changes
    setHasUnsavedCreateChanges(true);
    
    // Close the modal
    setCreateExpenseModal(false);
    setCreateExpenseEditMode(false);
    setSelectedCreateExpense(null);
  } catch (error) {
    console.error("Error handling expense:", error);
    alert("An error occurred while handling the expense. Please try again.");
  }
};

// Function to handle expense deletion in create mode
const handleConfirmDeleteCreateExpense = () => {
  if (!selectedCreateExpenseForDelete) return;
  
  try {
    const filteredExpenses = newCI.Expenses.filter((exp: ExpenseOBJ) => 
      exp.ID !== selectedCreateExpenseForDelete.ID
    );
    
    // Update newCI.Expenses
    setNewCI((prev: any) => ({
      ...prev,
      Expenses: filteredExpenses
    }));
    
    // Also update the redundant newCIExpenses array to keep them in sync
    setNewCIExpenses(filteredExpenses);
    
    // Mark form as having unsaved changes
    setHasUnsavedCreateChanges(true);
    
    setCreateExpenseDeleteModal(false);
    setSelectedCreateExpenseForDelete(null);
  } catch (error) {
    console.error("Error deleting expense:", error);
    alert("An error occurred while deleting the expense. Please try again.");
  }
};

// Add state to track unsaved changes in the create CI modal
const [hasUnsavedCreateChanges, setHasUnsavedCreateChanges] = useState(false);

// Store initial state of the create form for comparison
const initialCreateCIRef = useRef<any>(null);

// Function to handle input changes for new CI form
const handleNewCIInputChange = (field: keyof ContImproveOBJ, value: any) => {
  // For user fields, we need to convert to number if it's a user ID
  if (field === 'ProjCoord' || field === 'Approval1' || field === 'Approval2') {
    const numValue = value === '' ? null : parseInt(value);
    setNewCI({
      ...newCI,
      [field]: numValue
    });
  } else {
    setNewCI({
      ...newCI,
      [field]: value
    });
  }
  
  // Check for unsaved changes
  if (initialCreateCIRef.current) {
    setHasUnsavedCreateChanges(true);
  }
};

// Function to handle date input changes for new CI form
const handleNewCIDateChange = (field: keyof ContImproveOBJ, value: string) => {
  // Convert date string to Date object if not empty
  const dateValue = value ? new Date(value) : null;
  setNewCI({
    ...newCI,
    [field]: dateValue
  });
  
  // Check for unsaved changes
  if (initialCreateCIRef.current) {
    setHasUnsavedCreateChanges(true);
  }
};

// Function to open the create modal
const handleOpenCreateModal = () => {
  // Get current date for Date field
  const currentDate = new Date();
  
  // Reset form to empty values but set the current date
  const initialCI = {
    CRNumber: null,
    ProjName: '',
    Date: currentDate.toString(),
    ProjDesc: '',
    ProjCoord: null,
    ProjTeam: '',
    Duration: '',
    Estimated_Completetion_Date: null,
    StartDate: null,
    EndDate: null,
    Approval1: null,
    ApprovalDate1: null,
    Approval2: null,
    ApprovalDate2: null,
    Project_Rejected: null,
    Description_of_Result: '',
    Present_Target_Level_of_Performance: '',
    Monitoring_and_Measurement_Methods: '',
    Project_Tracking: '',
    Expenses: []
  };
  
  setNewCI(initialCI);
  
  // Store initial state for comparison
  initialCreateCIRef.current = {...initialCI};
  
  // Reset unsaved changes flag
  setHasUnsavedCreateChanges(false);
  
  // Reset the newCIExpenses array
  setNewCIExpenses([]);
  
  // Reset the expense form state
  setCreateExpenseMode(false);
  setEditingCreateExpenseIndex(null);
  setNewCreateExpense({
    ID: 0,
    CINumber: 0,
    ExpDesc: '',
    EstimatedCost: 0,
    Expense: 0,
    PO: ''
  });
  
  setCreateModalOpen(true);
};

// Modified function to handle closing the create modal
const handleCloseCreateModal = () => {
  // Check if there are unsaved changes
  if (hasUnsavedCreateChanges) {
    if (!window.confirm("You have unsaved changes. Are you sure you want to close this form?")) {
      return; // Cancel closing if user says no
    }
  }
  
  setCreateModalOpen(false);
  // Reset state
  setHasUnsavedCreateChanges(false);
  initialCreateCIRef.current = null;
};

// Function to submit new CI - modified to reset unsaved changes state
const handleSubmitNewCI = async () => {
  // Add confirmation dialog
  if (!window.confirm("Are you sure you want to create this CI record?")) {
    return; // Exit if user cancels
  }
  
  try {
    setLoading(true);
    
    // Clone newCI to avoid direct state mutation
    const ciToSubmit = { ...newCI };
    
    // Set date to null as it's handled by the backend
    ciToSubmit.Date = null;
    
    console.log("Submitting new CI:", ciToSubmit);
    
    // Call API to add new CI with expenses
    const response = await apiCalls.AddCI(ciToSubmit);
    console.log("Add CI Response:", response);
    
    // Reset unsaved changes flag
    setHasUnsavedCreateChanges(false);
    initialCreateCIRef.current = null;
    
    // Close the modal
    handleCloseCreateModal();
    
    // Refresh the data
    const refreshResponse = await apiCalls.GetAllCI();
    const mappedData = mapReportData(refreshResponse.data);
    setData(mappedData);
    
    alert("CI record created successfully!");
  } catch (error) {
    console.error("Error creating CI:", error);
    alert("Error creating CI. Please try again.");
  } finally {
    setLoading(false);
  }
};

// Update the handleAddNewReportClick function to open the create modal instead of navigating
const handleAddNewReportClick = () => {
  handleOpenCreateModal();
};

// Add a beforeunload event listener when the create modal is open
useEffect(() => {
  // Only add listener if modal is open and has unsaved changes
  if (createModalOpen && hasUnsavedCreateChanges) {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      const message = "You have unsaved changes. Are you sure you want to leave?";
      e.preventDefault();
      e.returnValue = message;
      return message;
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }
}, [createModalOpen, hasUnsavedCreateChanges]);

// Add a beforeunload event listener when the edit modal is open
useEffect(() => {
  // Only add listener if modal is open and has unsaved changes
  if (modalOpen && hasUnsavedEditChanges) {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      const message = "You have unsaved changes. Are you sure you want to leave?";
      e.preventDefault();
      e.returnValue = message;
      return message;
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }
}, [modalOpen, hasUnsavedEditChanges]);






  // Helper function to map report data with user names
  const mapReportData = (data: ContImproveOBJ[]) => {
    return data.map((item) => ({
      ...item,
      Date: item.Date ? new Date(item.Date) : null,
      Estimated_Completetion_Date: item.Estimated_Completetion_Date ? new Date(item.Estimated_Completetion_Date) : null,
      Project_Rejected: item.Project_Rejected ? new Date(item.Project_Rejected) : null,
      ApprovalDate1: item.ApprovalDate1 ? new Date(item.ApprovalDate1) : null,
      ApprovalDate2: item.ApprovalDate2 ? new Date(item.ApprovalDate2) : null,
      StartDate: item.StartDate ? new Date(item.StartDate) : null,
      EndDate: item.EndDate ? new Date(item.EndDate) : null,
      // Map user IDs to names - ensure we're actually getting the names
      ProjCoord: item.ProjCoord && users[item.ProjCoord] ? users[item.ProjCoord] : (item.ProjCoord || ''),
      Approval1: item.Approval1 && users[item.Approval1] ? users[item.Approval1] : (item.Approval1 || ''),
      Approval2: item.Approval2 && users[item.Approval2] ? users[item.Approval2] : (item.Approval2 || '')
    }));
  }

  // Add new state variables for expense editing
  const [newExpense, setNewExpense] = useState<ExpenseOBJ>({
    ID: 0,
    CINumber: 0,
    ExpDesc: '',
    EstimatedCost: 0,
    Expense: 0,
    PO: ''
  });

  const [editExpenseMode, setEditExpenseMode] = useState(false);
  const [editingExpenseId, setEditingExpenseId] = useState<number | null>(null);
  const [expenseModal, setExpenseModal] = useState(false);
const [expenseEditMode, setExpenseEditMode] = useState(false);
const [selectedExpenseForDelete, setSelectedExpenseForDelete] = useState<ExpenseOBJ | null>(null);
const [expenseDeleteModal, setExpenseDeleteModal] = useState(false);

// Function to reset the new expense form
const resetExpenseForm = () => {
  setNewExpense({
    ID: 0,
    CINumber: 0,
    ExpDesc: '',
    EstimatedCost: 0,
    Expense: 0,
    PO: ''
  });
  setEditExpenseMode(false);
  setEditingExpenseId(null);
};

// Function to handle adding a new expense
const handleAddExpense = () => {
  setNewExpense({
    ID: 0,
    CINumber: selectedCI ? selectedCI.CINumber : 0,
    ExpDesc: '',
    EstimatedCost: 0,
    Expense: 0,
    PO: ''
  });
  setExpenseEditMode(false);
  setExpenseModal(true);
};

  // Function to handle saving edited expense
  const handleSaveExpense = async () => {
    if (!selectedCI || editingExpenseId === null) return;
    
    // Validate that description is provided
    if (!newExpense.ExpDesc || newExpense.ExpDesc.trim() === "") {
      alert("Description is required for expenses.");
      return;
    }
    
    // Add confirmation dialog
    if (!window.confirm("Are you sure you want to save changes to this expense?")) {
      return; // Exit if user cancels
    }
    
    try {
      setLoadingDetails(true);
      
      // Prepare expense data
      const expenseData = {
        ...newExpense,
        ID: editingExpenseId,
        CINumber: selectedCI.CINumber
      };
      
      // Call API to update expense
      const response = await apiCalls.EditExpense(expenseData);
      console.log("Update Expense Response:", response);
      
      // Refresh data to show updated values
      await fetchCIDetails(selectedCI.CINumber);
      
      // Reset form
      resetExpenseForm();
      

      
    } catch (error) {
      console.error("Error updating expense:", error);
      alert("Error updating expense. Please try again.");
    } finally {
      setLoadingDetails(false);
    }
  };

  // Function to handle deleting an expense
  const handleDeleteExpense = (expenseId: number) => {
    const expense = selectedCIExpenses.find(exp => exp.ID === expenseId);
    if (expense) {
      setSelectedExpenseForDelete(expense);
      setExpenseDeleteModal(true);
    }
  };

  // Function to handle editing an expense
const handleEditExpense = (expense: ExpenseOBJ) => {
  // Set the selected expense for editing
  setNewExpense({
    ID: expense.ID,
    CINumber: expense.CINumber,
    ExpDesc: expense.ExpDesc || '',
    EstimatedCost: expense.EstimatedCost,
    Expense: expense.Expense,
    PO: expense.PO || ''
  });
  
  // Set the editing ID
  setEditingExpenseId(expense.ID);
  
  // Enable edit mode
  setExpenseEditMode(true);
  
  // Open the expense modal
  setExpenseModal(true);
};

  // Add this new function to confirm expense deletion
const confirmDeleteExpense = async () => {
  if (!selectedCI || !selectedExpenseForDelete) return;
  
  try {
    setLoadingDetails(true);
    
    // Call API to delete expense
    const response = await apiCalls.DeleteExpense(selectedExpenseForDelete.ID);
    
    if (response && response.status === 200) {
      // Refresh data to show updated values
      await fetchCIDetails(selectedCI.CINumber);
      setExpenseDeleteModal(false);
      setSelectedExpenseForDelete(null);
    } else {
      alert("Error deleting expense. Please try again.");
    }
  } catch (error) {
    console.error("Error deleting expense:", error);
    alert("Error deleting expense. Please try again.");
  } finally {
    setLoadingDetails(false);
  }
};

// Add this new function to handle the expense form submission
const handleExpenseSubmit = async () => {
  if (!selectedCI) return;
  
  try {
    setLoadingDetails(true);
    
    if (expenseEditMode) {
      // Edit existing expense
      const expenseData = {
        ...newExpense,
        ID: editingExpenseId,
        CINumber: selectedCI.CINumber
      };
      
      const response = await apiCalls.EditExpense(expenseData);
      
      if (response && response.status === 200) {
        // Refresh data to show updated values
        await fetchCIDetails(selectedCI.CINumber);
        setExpenseModal(false);
        resetExpenseForm();
      } else {
        alert("Error updating expense. Please try again.");
      }
    } else {
      // Add new expense
      const expenseData = {
        ...newExpense,
        CINumber: selectedCI.CINumber
      };
      
      const response = await apiCalls.AddExpense(expenseData);
      
      if (response && response.status === 200) {
        // Refresh data to show updated values
        await fetchCIDetails(selectedCI.CINumber);
        setExpenseModal(false);
        resetExpenseForm();
      } else {
        alert("Error adding expense. Please try again.");
      }
    }
  } catch (error) {
    console.error(`Error ${expenseEditMode ? 'updating' : 'adding'} expense:`, error);
    alert(`Error ${expenseEditMode ? 'updating' : 'adding'} expense. Please try again.`);
  } finally {
    setLoadingDetails(false);
  }
};

  const handleExpenseInputChange = (field: keyof ExpenseOBJ, value: any) => {
    setNewExpense({
      ...newExpense,
      [field]: value
    });
    
    // Mark form as having unsaved changes
    setHasUnsavedEditChanges(true);
  };

  // Add these missing state variables
const [newCIExpenses, setNewCIExpenses] = useState<ExpenseOBJ[]>([]);
const [createExpenseMode, setCreateExpenseMode] = useState(false);
const [editingCreateExpenseIndex, setEditingCreateExpenseIndex] = useState<number | null>(null);


  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: '#0e226a',
        color: "#000000",
        padding: "1.5rem 1rem"
      }}
    >
      <div style={{ marginTop: "0px" }}>
        <Header />
      </div>
      
      {/* Filter Container for report type filter only */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", marginBottom: "10px" }}>
        <div
          style={{
            backgroundColor: "#efefef",
            borderRadius: "8px",
            padding: "10px",
            display: "flex",
            justifyContent: "center",
            margin: "5px auto",
            width: "fit-content" // shrink container to content width
          }}
        >
          <label style={{ marginRight: "20px" }}>
            <input
              type="radio"
              value="all reports"
              checked={selectedFilter === "all reports"}
              onChange={() => handleFilterChange("all reports")}
              style={{ marginRight: "5px" }}
            />
            All CI Projects
          </label>
          <label style={{ marginRight: "20px" }}>
            <input
              type="radio"
              value="active reports"
              checked={selectedFilter === "active reports"}
              onChange={() => handleFilterChange("active reports")}
              style={{ marginRight: "5px" }}
            />
            Active CI Projects
          </label>
          <label>
            <input
              type="radio"
              value="closed reports"
              checked={selectedFilter === "closed reports"}
              onChange={() => handleFilterChange("closed reports")}
              style={{ marginRight: "5px" }}
            />
            Closed CI Projects
          </label>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', marginTop: '10px' }}>
        <Button
          color="primary"
          onClick={handleAddNewReportClick}
          style={{
            fontSize: '18px',
            padding: '5px 10px',
            margin: '0 5px',
            backgroundColor: '#efefef',
            color: '#000000',
            outline: '1px solid black',
            marginBottom: '20px'
          }}
        >
          Create New CI
        </Button>


         {/* <Button
          color="primary"
          onClick={() => navigate('/menu')}
          style={{
            fontSize: '18px',
            padding: '5px 10px',
            margin: '0 5px',
            backgroundColor: '#efefef',
            color: '#000000',
            outline: '1px solid black',
            marginBottom: '20px'
          }}
        >
          Return to Menu
        </Button>  */}
        <Button
          color="primary"
          onClick={() => navigate('/conditionreports')}
          style={{
            fontSize: '18px',
            padding: '5px 10px',
            margin: '0 5px',
            backgroundColor: '#efefef',
            color: '#000000',
            outline: '1px solid black',
            marginBottom: '20px'
          }}
        >
          Condition Reports
        </Button> 
        </div>
        <div style={{ 
          backgroundColor: "#efefef", 
          color: "#000000", 
          padding: "0",
          width: "100%",
          overflow: "auto",
          marginLeft: "-0.5rem",
          marginRight: "-0.5rem"
        }}>
        <DataGridPro
          rows={rows}
          columns={columns2}
          getRowId={(row) => row.CINumber}
          onRowDoubleClick={onRowDoubleClick}
          style={{ width: "100%", height: "70vh" }}
          loading={loading} // Built-in loading property
          slots={{
            loadingOverlay: () => <DataLoading />, // Custom loading overlay
            noRowsOverlay: () => (
              <div
                style={{
                  display: 'flex',
                  top: '40%', // Adjust this to move the loader vertically
                  left: '50%', // Center horizontally
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  fontSize: '18px',
                  color: '#ef9a9a',
                }}
              >
                No contents here !!!
              </div>
            ),
          }}
          rowHeight={65}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 100 }
            },
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
              width: "100%",
              margin: 0,
              padding: 0
            },
            "& .MuiDataGrid-main": {
              width: "100%",
              maxWidth: "100%"
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0e226a !important",
              color: "#FFFFFF",
              fontWeight: "bold",
              fontSize: "0.75rem",
              lineHeight: "1.1"
            },
            "& .MuiDataGrid-cell": {
              fontSize: "0.75rem",
              padding: "4px",
              whiteSpace: "normal",
              lineHeight: "1.3",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "visible",
              wordBreak: "break-word",
              verticalAlign: "middle",
              "& > div": {
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                verticalAlign: "middle"
              }
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#0e226a !important",
              padding: "4px 2px"
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "pre-line",
              lineHeight: "1.1",
              textAlign: "center",
              padding: "0 4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%"
            },
            "& .MuiDataGrid-columnHeaderTitleContainer": {
              justifyContent: "center",
              padding: "0 2px",
              height: "100%",
              display: "flex",
              alignItems: "center"
            },
            "& .MuiDataGrid-columnHeaderContent": {
              justifyContent: "center",
              height: "100%",
              display: "flex",
              alignItems: "center"
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "#0e226a",
              color: '#FFFFFF'
            },
            "& .MuiDataGrid-row:hover .MuiCheckbox-root": {
              color: "#FFFFFF"
            },
            "& .MuiDataGrid-row:hover .MuiCheckbox-root.Mui-checked": {
              color: "#FFFFFF"
            },
            "& .Mui-selected": {
              backgroundColor: "#0e226a !important",
              color: "#fff !important"
            },
            "& .MuiDataGrid-iconButtonContainer": {
              color: "white"
            },
            "& .MuiDataGrid-sortIcon": {
              color: "white"
            },
            "& .MuiDataGrid-menuIcon": {
              color: "white"
            },
            // Additional styling for menu icons and buttons - more specific selectors
            "& .MuiDataGrid-columnHeader .MuiButtonBase-root": {
              color: "white"
            },
            "& .MuiDataGrid-columnHeaderMenuButton": {
              color: "white"
            },
            "& .MuiDataGrid-columnHeader .MuiIconButton-root": {
              color: "white"
            },
            "& .MuiMenu-paper .MuiMenuItem-root": {
              fontSize: "0.875rem"
            },
            // Enhanced targeting for the specific menu icon in the column header
            "& .MuiDataGrid-columnHeader .MuiDataGrid-menuIconButton": {
              color: "white"
            },
            "& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer button": {
              color: "white"
            },
            "& .MuiDataGrid-columnHeader .MuiSvgIcon-root": {
              color: "white"
            },
            // Explicitly style checkboxes back to their original color
            "& .MuiCheckbox-root": {
              color: "#0e226a"
            },
            "& .MuiCheckbox-root.Mui-checked": {
              color: "#0e226a"
            }
          }}
        />
        </div>
      {/* Add the modal dialog */}
      <Modal
        isOpen={modalOpen}
        toggle={handleCloseModal}
        size="xl"
        style={{ maxWidth: '90%', width: '90%' }}
      >
        <ModalHeader 
          style={{ backgroundColor: '#0e226a', color: 'white', position: 'relative' }}
        >
          Edit Continuous Improvement - CI #{selectedCI?.CINumber || 'Loading...'}
          {hasUnsavedEditChanges && (
            <div style={{ 
              fontSize: '0.8rem', 
              fontStyle: 'italic', 
              fontWeight: 'normal',
              color: '#ffcc00'
            }}>
              * You have unsaved changes
            </div>
          )}
          <Button
            color="secondary"
            onClick={handleCloseModal}
            style={{
              position: 'absolute',
              right: '1rem',
              top: '0.5rem',
              backgroundColor: 'white',
              color: '#0e226a',
              fontWeight: 'bold',
              padding: '0.25rem 0.75rem',
              fontSize: '0.875rem',
              borderRadius: '4px',
              border: 'none'
            }}
          >
            Close
          </Button>
        </ModalHeader>
        <ModalBody>
          {loadingDetails ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
              <BounceLoader color={"#123abc"} loading={true} size={60} />
            </div>
          ) : editedCI ? (
            <div className="container">
              <h4 style={{ color: '#0e226a', marginBottom: '20px' }}>Project Information</h4>
              
              <div className="row mb-4">
                <div className="col-md-6">
                  <div className="card p-3 mb-3">
                    <div className="card-body">
                      <div className="form-group mb-3">
                        <label><strong>CI Number:</strong></label>
                        <input 
                          type="text" 
                          className="form-control" 
                          value={editedCI.CINumber || ''} 
                          disabled={true} 
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>CR Number:</strong></label>
                        <input 
                          type="text" 
                          className="form-control" 
                          value={editedCI.CRNumber || ''} 
                          onChange={(e) => handleInputChange('CRNumber', e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Project Name:</strong></label>
                        <input 
                          type="text" 
                          className="form-control" 
                          value={editedCI.ProjName || ''} 
                          onChange={(e) => handleInputChange('ProjName', e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Date Created:</strong></label>
                        <input 
                          type="date" 
                          className="form-control" 
                          value={editedCI.Date ? new Date(editedCI.Date).toISOString().split('T')[0] : ''} 
                          onChange={(e) => handleDateChange('Date', e.target.value)}
                          disabled={true}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Project Description:</strong></label>
                        <textarea 
                          className="form-control" 
                          rows={5}  // Increased from 3 to 5
                          style={{ minHeight: "120px" }}  // Added explicit height
                          value={editedCI.ProjDesc || ''} 
                          onChange={(e) => handleInputChange('ProjDesc', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card p-3 mb-3">
                    <div className="card-body">
                      <div className="form-group mb-3">
                        <label><strong>Coordinator:</strong></label>
                        <select 
                          className="form-control" 
                          value={editedCI.ProjCoord || ''}
                          onChange={(e) => handleInputChange('ProjCoord', e.target.value)}
                        >
                          <option value="">Select Coordinator</option>
                          {CRUsers.map((user) => (
                            <option key={user.userID} value={user.userID}>
                              {user.FullName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Team:</strong></label>
                        <input 
                          type="text" 
                          className="form-control" 
                          value={editedCI.ProjTeam || ''} 
                          onChange={(e) => handleInputChange('ProjTeam', e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Duration:</strong></label>
                        <input 
                          type="text" 
                          className="form-control" 
                          value={editedCI.Duration || ''} 
                          onChange={(e) => handleInputChange('Duration', e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Est. Completion:</strong></label>
                        <input 
                          type="date" 
                          className="form-control" 
                          value={editedCI.Estimated_Completetion_Date ? new Date(editedCI.Estimated_Completetion_Date).toISOString().split('T')[0] : ''} 
                          onChange={(e) => handleDateChange('Estimated_Completetion_Date', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="row mb-4">
                <div className="col-md-6">
                  <div className="card p-3 mb-3">
                    <div className="card-body">
                      <div className="form-group mb-3">
                        <label><strong>Start Date:</strong></label>
                        <input 
                          type="date" 
                          className="form-control" 
                          value={editedCI.StartDate ? new Date(editedCI.StartDate).toISOString().split('T')[0] : ''} 
                          onChange={(e) => handleDateChange('StartDate', e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>End Date:</strong></label>
                        <input 
                          type="date" 
                          className="form-control" 
                          value={editedCI.EndDate ? new Date(editedCI.EndDate).toISOString().split('T')[0] : ''} 
                          onChange={(e) => handleDateChange('EndDate', e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Rejected Date:</strong></label>
                        <input 
                          type="date" 
                          className="form-control" 
                          value={editedCI.Project_Rejected ? new Date(editedCI.Project_Rejected).toISOString().split('T')[0] : ''} 
                          onChange={(e) => handleDateChange('Project_Rejected', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card p-3 mb-3">
                    <div className="card-body">
                      <div className="form-group mb-3">
                        <label><strong>Approval 1:</strong></label>
                        <select 
                          className="form-control" 
                          value={editedCI.Approval1 || ''}
                          onChange={(e) => handleInputChange('Approval1', e.target.value)}
                        >
                          <option value="">Select Approver 1</option>
                          {CRUsers.map((user) => (
                            <option key={user.userID} value={user.userID}>
                              {user.FullName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Approval 1 Date:</strong></label>
                        <input 
                          type="date" 
                          className="form-control" 
                          value={editedCI.ApprovalDate1 ? new Date(editedCI.ApprovalDate1).toISOString().split('T')[0] : ''} 
                          onChange={(e) => handleDateChange('ApprovalDate1', e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Approval 2:</strong></label>
                        <select 
                          className="form-control" 
                          value={editedCI.Approval2 || ''}
                          onChange={(e) => handleInputChange('Approval2', e.target.value)}
                        >
                          <option value="">Select Approver 2</option>
                          {CRUsers.map((user) => (
                            <option key={user.userID} value={user.userID}>
                              {user.FullName}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Approval 2 Date:</strong></label>
                        <input 
                          type="date" 
                          className="form-control" 
                          value={editedCI.ApprovalDate2 ? new Date(editedCI.ApprovalDate2).toISOString().split('T')[0] : ''} 
                          onChange={(e) => handleDateChange('ApprovalDate2', e.target.value)}
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              
              <div className="row mb-4">
                <div className="col-12">
                  <div className="card p-3 mb-3">
                    <div className="card-body">
                      <div className="form-group mb-3">
                        <label><strong>Description of Results:</strong></label>
                        <textarea 
                          className="form-control" 
                          rows={6}  // Increased from 3 to 6
                          style={{ minHeight: "140px" }}  // Added explicit height
                          value={editedCI.Description_of_Result || ''} 
                          onChange={(e) => handleInputChange('Description_of_Result', e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Target Performance:</strong></label>
                        <textarea 
                          className="form-control" 
                          rows={6}  // Increased from 3 to 6
                          style={{ minHeight: "140px" }}  // Added explicit height
                          value={editedCI.Present_Target_Level_of_Performance || ''} 
                          onChange={(e) => handleInputChange('Present_Target_Level_of_Performance', e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Monitoring Methods:</strong></label>
                        <textarea 
                          className="form-control" 
                          rows={6}  // Increased from 3 to 6
                          style={{ minHeight: "140px" }}  // Added explicit height
                          value={editedCI.Monitoring_and_Measurement_Methods || ''} 
                          onChange={(e) => handleInputChange('Monitoring_and_Measurement_Methods', e.target.value)}
                        />
                      </div>
                      <div className="form-group mb-3">
                        <label><strong>Project Tracking:</strong></label>
                        <textarea 
                          className="form-control" 
                          rows={6}  // Increased from 3 to 6
                          style={{ minHeight: "140px" }}  // Added explicit height
                          value={editedCI.Project_Tracking || ''} 
                          onChange={(e) => handleInputChange('Project_Tracking', e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <h4 style={{ color: '#0e226a', marginTop: '30px', marginBottom: '20px' }}>Project Expenses</h4>
              <div className="card p-3 mb-3">
                <div className="card-body">
                  <Button 
                    color="primary" 
                    onClick={handleAddExpense}
                    style={{ backgroundColor: '#0e226a', color: 'white', marginBottom: '15px' }}
                  >
                    Add Expense
                  </Button>

                  {/* Expenses Table */}
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead style={{ backgroundColor: '#0e226a', color: 'white' }}>
                        <tr>
                          <th>Description</th>
                          <th>Estimated Cost</th>
                          <th>Purchase Order</th>
                          <th>Actual Expense</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedCIExpenses && selectedCIExpenses.length > 0 ? (
                          selectedCIExpenses.map((expense) => (
                            <tr key={expense.ID}>
                              <td>{expense.ExpDesc || 'N/A'}</td>
                              <td>${expense.EstimatedCost ? expense.EstimatedCost.toFixed(2) : '0.00'}</td>
                              <td>{expense.PO || 'N/A'}</td>
                              <td>${expense.Expense ? expense.Expense.toFixed(2) : '0.00'}</td>
                              
                              <td style={{ whiteSpace: 'nowrap' }}>
                                <Button 
                                  color="primary" 
                                  size="sm" 
                                  className="me-1"
                                  onClick={() => handleEditExpense(expense)}
                                  disabled={loadingDetails}
                                  style={{ backgroundColor: '#0e226a', color: 'white', marginRight: '5px' }}
                                >
                                  Edit
                                </Button>
                                <Button 
                                  color="danger" 
                                  size="sm"
                                  onClick={() => handleDeleteExpense(expense.ID)}
                                  disabled={loadingDetails}
                                >
                                  Delete
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={5} className="text-center">No expenses found for this CI project</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div style={{ padding: '40px', textAlign: 'center' }}>
              <p style={{ fontSize: '18px', color: '#ef9a9a' }}>
                No data available for this CI project. Please try again or contact support.
              </p>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button 
            onClick={handleSubmitChanges} 
            color="primary" 
            style={{ marginRight: '10px', backgroundColor: '#0e226a', color: 'white' }}
            disabled={loadingDetails}
          >
            Submit Changes
          </Button>
          <Button 
            onClick={handleCloseModal} 
            color="secondary"
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
      {/* New modal for creating CI */}
      <Modal
        isOpen={createModalOpen}
        toggle={handleCloseCreateModal}
        size="xl"
        style={{ maxWidth: '90%', width: '90%' }}
      >
        <ModalHeader 
          style={{ backgroundColor: '#0e226a', color: 'white', position: 'relative' }}
        >
          Create New Continuous Improvement
          {hasUnsavedCreateChanges && (
            <div style={{ 
              fontSize: '0.8rem', 
              fontStyle: 'italic', 
              fontWeight: 'normal',
              color: '#ffcc00'
            }}>
              * You have unsaved changes
            </div>
          )}
          <Button
            color="secondary"
            onClick={handleCloseCreateModal}
            style={{
              position: 'absolute',
              right: '1rem',
              top: '0.5rem',
              backgroundColor: 'white',
              color: '#0e226a',
              fontWeight: 'bold',
              padding: '0.25rem 0.75rem',
              fontSize: '0.875rem',
              borderRadius: '4px',
              border: 'none'
            }}
          >
            Close
          </Button>
        </ModalHeader>
        <ModalBody>
          <div className="container">
            <h4 style={{ color: '#0e226a', marginBottom: '20px' }}>Project Information</h4>
            
            <div className="row mb-4">
              <div className="col-md-6">
                <div className="card p-3 mb-3">
                  <div className="card-body">
                    <div className="form-group mb-3">
                      <label><strong>CR Number:</strong></label>
                      <input 
                        type="text" 
                        className="form-control" 
                        value={newCI.CRNumber || ''} 
                        onChange={(e) => handleNewCIInputChange('CRNumber', e.target.value ? parseInt(e.target.value) : null)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Project Name:</strong></label>
                      <input 
                        type="text" 
                        className="form-control" 
                        value={newCI.ProjName || ''} 
                        onChange={(e) => handleNewCIInputChange('ProjName', e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Date Created:</strong></label>
                      <input 
                        type="text" 
                        className="form-control" 
                        value={new Date().toISOString().split('T')[0]} 
                        disabled={true}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Project Description:</strong></label>
                      <textarea 
                        className="form-control" 
                        rows={5}  // Increased from 3 to 5
                        style={{ minHeight: "120px" }}  // Added explicit height
                        value={newCI.ProjDesc || ''} 
                        onChange={(e) => handleNewCIInputChange('ProjDesc', e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card p-3 mb-3">
                  <div className="card-body">
                    <div className="form-group mb-3">
                      <label><strong>Coordinator:</strong></label>
                      <select 
                        className="form-control" 
                        value={newCI.ProjCoord || ''}
                        onChange={(e) => handleNewCIInputChange('ProjCoord', e.target.value)}
                      >
                        <option value="">Select Coordinator</option>
                        {CRUsers.map((user) => (
                          <option key={user.userID} value={user.userID}>
                            {user.FullName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Team:</strong></label>
                      <input 
                        type="text" 
                        className="form-control" 
                        value={newCI.ProjTeam || ''} 
                        onChange={(e) => handleNewCIInputChange('ProjTeam', e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Duration:</strong></label>
                      <input 
                        type="text" 
                        className="form-control" 
                        value={newCI.Duration || ''} 
                        onChange={(e) => handleNewCIInputChange('Duration', e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Est. Completion:</strong></label>
                      <input 
                        type="date" 
                        className="form-control" 
                        value={newCI.Estimated_Completetion_Date ? new Date(newCI.Estimated_Completetion_Date).toISOString().split('T')[0] : ''} 
                        onChange={(e) => handleNewCIDateChange('Estimated_Completetion_Date', e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="row mb-4">
              <div className="col-md-6">
                <div className="card p-3 mb-3">
                  <div className="card-body">
                    <div className="form-group mb-3">
                      <label><strong>Start Date:</strong></label>
                      <input 
                        type="date" 
                        className="form-control" 
                        value={newCI.StartDate ? new Date(newCI.StartDate).toISOString().split('T')[0] : ''} 
                        onChange={(e) => handleNewCIDateChange('StartDate', e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>End Date:</strong></label>
                      <input 
                        type="date" 
                        className="form-control" 
                        value={newCI.EndDate ? new Date(newCI.EndDate).toISOString().split('T')[0] : ''} 
                        onChange={(e) => handleNewCIDateChange('EndDate', e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Rejected Date:</strong></label>
                      <input 
                        type="date" 
                        className="form-control" 
                        value={newCI.Project_Rejected ? new Date(newCI.Project_Rejected).toISOString().split('T')[0] : ''} 
                        onChange={(e) => handleNewCIDateChange('Project_Rejected', e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card p-3 mb-3">
                  <div className="card-body">
                    <div className="form-group mb-3">
                      <label><strong>Approval 1:</strong></label>
                      <select 
                        className="form-control" 
                        value={newCI.Approval1 || ''}
                        onChange={(e) => handleNewCIInputChange('Approval1', e.target.value)}
                      >
                        <option value="">Select Approver 1</option>
                        {CRUsers.map((user) => (
                          <option key={user.userID} value={user.userID}>
                            {user.FullName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Approval 1 Date:</strong></label>
                      <input 
                        type="date" 
                        className="form-control" 
                        value={newCI.ApprovalDate1 ? new Date(newCI.ApprovalDate1).toISOString().split('T')[0] : ''} 
                        onChange={(e) => handleNewCIDateChange('ApprovalDate1', e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Approval 2:</strong></label>
                      <select 
                        className="form-control" 
                        value={newCI.Approval2 || ''}
                        onChange={(e) => handleNewCIInputChange('Approval2', e.target.value)}
                      >
                        <option value="">Select Approver 2</option>
                        {CRUsers.map((user) => (
                          <option key={user.userID} value={user.userID}>
                            {user.FullName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Approval 2 Date:</strong></label>
                      <input 
                        type="date" 
                        className="form-control" 
                        value={newCI.ApprovalDate2 ? new Date(newCI.ApprovalDate2).toISOString().split('T')[0] : ''} 
                        onChange={(e) => handleNewCIDateChange('ApprovalDate2', e.target.value)}
                      />
                    </div>

                  </div>
                </div>
              </div>
            </div>
            
            <div className="row mb-4">
              <div className="col-12">
                <div className="card p-3 mb-3">
                  <div className="card-body">
                    <div className="form-group mb-3">
                      <label><strong>Description of Results:</strong></label>
                      <textarea 
                        className="form-control" 
                        rows={6}  // Increased from 3 to 6
                        style={{ minHeight: "140px" }}  // Added explicit height
                        value={newCI.Description_of_Result || ''} 
                        onChange={(e) => handleNewCIInputChange('Description_of_Result', e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Target Performance:</strong></label>
                      <textarea 
                        className="form-control" 
                        rows={6}  // Increased from 3 to 6
                        style={{ minHeight: "140px" }}  // Added explicit height
                        value={newCI.Present_Target_Level_of_Performance || ''} 
                        onChange={(e) => handleNewCIInputChange('Present_Target_Level_of_Performance', e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Monitoring Methods:</strong></label>
                      <textarea 
                        className="form-control" 
                        rows={6}  // Increased from 3 to 6
                        style={{ minHeight: "140px" }}  // Added explicit height
                        value={newCI.Monitoring_and_Measurement_Methods || ''} 
                        onChange={(e) => handleNewCIInputChange('Monitoring_and_Measurement_Methods', e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label><strong>Project Tracking:</strong></label>
                      <textarea 
                        className="form-control" 
                        rows={6}  // Increased from 3 to 6
                        style={{ minHeight: "140px" }}  // Added explicit height
                        value={newCI.Project_Tracking || ''} 
                        onChange={(e) => handleNewCIInputChange('Project_Tracking', e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Add Project Expenses section */}
          <h4 style={{ color: '#0e226a', marginTop: '30px', marginBottom: '20px' }}>Project Expenses</h4>
          <div className="card p-3 mb-3">
            <div className="card-body">
              <Button 
                color="primary" 
                onClick={handleAddCreateExpense}
                style={{ backgroundColor: '#0e226a', color: 'white', marginBottom: '15px' }}
              >
                Add Expense
              </Button>

              {/* Expenses Table */}
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead style={{ backgroundColor: '#0e226a', color: 'white' }}>
                    <tr>
                      <th>Description</th>
                      <th>Estimated Cost</th>
                      <th>Purchase Order</th>
                      <th>Actual Expense</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {newCI.Expenses && newCI.Expenses.length > 0 ? (
                      newCI.Expenses.map((expense, index) => (
                        <tr key={index}>
                          <td>{expense.ExpDesc || 'N/A'}</td>
                          <td>${expense.EstimatedCost?.toFixed(2) || '0.00'}</td>
                          <td>${expense.Expense?.toFixed(2) || '0.00'}</td>
                          <td>{expense.PO || 'N/A'}</td>
                          <td style={{ whiteSpace: 'nowrap' }}>
                            <Button 
                              color="primary" 
                              size="sm" 
                              className="me-1"
                              onClick={() => handleEditCreateExpense(expense)}
                              disabled={loading}
                              style={{ backgroundColor: '#0e226a', color: 'white', marginRight: '5px' }}
                            >
                              Edit
                            </Button>
                            <Button 
                              color="danger" 
                              size="sm"
                              onClick={() => handleDeleteCreateExpense(expense)}
                              disabled={loading}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5} className="text-center">No expenses added yet</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button 
            onClick={handleSubmitNewCI} 
            color="primary" 
            style={{ marginRight: '10px', backgroundColor: '#0e226a', color: 'white' }}
            disabled={loading}
          >
            Create CI
          </Button>
          <Button 
            onClick={handleCloseCreateModal} 
            color="secondary"
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <ToastContainer />
      {/* Add/Edit Expense Modal */}
      <Modal isOpen={expenseModal} toggle={() => setExpenseModal(false)} centered size="md">
        <ModalHeader 
          style={{ backgroundColor: '#0e226a', color: 'white', position: 'relative' }}
        >
          {expenseEditMode ? 'Edit Expense' : 'Add New Expense'}
          <Button
            color="secondary"
            onClick={() => setExpenseModal(false)}
            style={{
              position: 'absolute',
              right: '1rem',
              top: '0.5rem',
              backgroundColor: 'white',
              color: '#0e226a',
              fontWeight: 'bold',
              padding: '0.25rem 0.75rem',
              fontSize: '0.875rem',
              borderRadius: '4px',
              border: 'none'
            }}
          >
            Close
          </Button>
        </ModalHeader>
        <ModalBody style={{ backgroundColor: '#efefef' }}>
          <FormGroup>
            <Label for="ExpDesc">Description <span className="text-danger">*</span></Label>
            <Input
              type="text"
              id="ExpDesc"
              value={newExpense.ExpDesc || ''}
              onChange={(e) => handleExpenseInputChange('ExpDesc', e.target.value)}
              placeholder="Enter expense description"
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="EstimatedCost">Estimated Cost</Label>
            <Input
              type="number"
              id="EstimatedCost"
              value={newExpense.EstimatedCost || 0}
              onChange={(e) => handleExpenseInputChange('EstimatedCost', parseFloat(e.target.value) || 0)}
              placeholder="Enter estimated cost"
              step="0.01"
            />
          </FormGroup>
          <FormGroup>
            <Label for="Expense">Actual Expense</Label>
            <Input
              type="number"
              id="Expense"
              value={newExpense.Expense || 0}
              onChange={(e) => handleExpenseInputChange('Expense', parseFloat(e.target.value) || 0)}
              placeholder="Enter actual expense"
              step="0.01"
            />
          </FormGroup>
          <FormGroup>
            <Label for="PO">Purchase Order</Label>
            <Input
              type="text"
              id="PO"
              value={newExpense.PO || ''}
              onChange={(e) => handleExpenseInputChange('PO', e.target.value)}
              placeholder="Enter purchase order number"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter style={{ backgroundColor: '#efefef' }}>
          <Button color="secondary" onClick={() => setExpenseModal(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleExpenseSubmit} style={{ backgroundColor: '#0e226a' }}>
            {expenseEditMode ? 'Update' : 'Add'} Expense
          </Button>
        </ModalFooter>
      </Modal>

      {/* Delete Expense Confirmation Modal */}
      <Modal isOpen={expenseDeleteModal} toggle={() => setExpenseDeleteModal(false)} centered>
        <ModalHeader toggle={() => setExpenseDeleteModal(false)} style={{ backgroundColor: '#dc3545', color: 'white' }}>
          Confirm Deletion
        </ModalHeader>
        <ModalBody>
          <p>Are you sure you want to delete this expense?</p>
          {selectedExpenseForDelete && (
            <div>
              <p><strong>Description:</strong> {selectedExpenseForDelete.ExpDesc || 'N/A'}</p>
              <p><strong>Estimated Cost:</strong> ${selectedExpenseForDelete.EstimatedCost?.toFixed(2) || '0.00'}</p>
              <p><strong>Actual Expense:</strong> ${selectedExpenseForDelete.Expense?.toFixed(2) || '0.00'}</p>
            </div>
          )}
          <div className="alert alert-warning mt-3">
            <i className="fa fa-exclamation-triangle mr-2"></i>
            This action cannot be undone.
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setExpenseDeleteModal(false)}>
            Cancel
          </Button>
          <Button color="danger" onClick={confirmDeleteExpense}>
            Delete
          </Button>
        </ModalFooter>
      </Modal>
      {/* Add/Edit Expense Modal for Create CI */}
<Modal isOpen={createExpenseModal} toggle={() => setCreateExpenseModal(false)} centered size="md">
  <ModalHeader 
    style={{ backgroundColor: '#0e226a', color: 'white', position: 'relative' }}
  >
    {createExpenseEditMode ? 'Edit Expense' : 'Add New Expense'}
    <Button
      color="secondary"
      onClick={() => setCreateExpenseModal(false)}
      style={{
        position: 'absolute',
        right: '1rem',
        top: '0.5rem',
        backgroundColor: 'white',
        color: '#0e226a',
        fontWeight: 'bold',
        padding: '0.25rem 0.75rem',
        fontSize: '0.875rem',
        borderRadius: '4px',
        border: 'none'
      }}
    >
      Close
    </Button>
  </ModalHeader>
  <ModalBody style={{ backgroundColor: '#efefef' }}>
    <FormGroup>
      <Label for="ExpDesc">Description <span className="text-danger">*</span></Label>
      <Input
        type="text"
        id="ExpDesc"
        value={createExpenseEditMode ? selectedCreateExpense?.ExpDesc ?? '' : newCreateExpense.ExpDesc ?? ''}        
        onChange={(e) => handleCreateExpenseInputChange('ExpDesc', e.target.value)}
        placeholder="Enter expense description"
        required
      />
    </FormGroup>
    <FormGroup>
      <Label for="EstimatedCost">Estimated Cost</Label>
      <Input
        type="number"
        id="EstimatedCost"
        value={createExpenseEditMode ? selectedCreateExpense?.EstimatedCost || 0 : newCreateExpense.EstimatedCost}
        onChange={(e) => handleCreateExpenseInputChange('EstimatedCost', parseFloat(e.target.value) || 0)}
        placeholder="Enter estimated cost"
        step="0.01"
      />
    </FormGroup>
    <FormGroup>
      <Label for="Expense">Actual Expense</Label>
      <Input
        type="number"
        id="Expense"
        value={createExpenseEditMode ? selectedCreateExpense?.Expense || 0 : newCreateExpense.Expense}
        onChange={(e) => handleCreateExpenseInputChange('Expense', parseFloat(e.target.value) || 0)}
        placeholder="Enter actual expense"
        step="0.01"
      />
    </FormGroup>
    <FormGroup>
      <Label for="PO">Purchase Order</Label>
      <Input
        type="text"
        id="PO"
        value={createExpenseEditMode ? selectedCreateExpense?.PO ?? '' : newCreateExpense.PO ?? ''}
        onChange={(e) => handleCreateExpenseInputChange('PO', e.target.value)}
        placeholder="Enter purchase order number"
      />
    </FormGroup>
  </ModalBody>
  <ModalFooter style={{ backgroundColor: '#efefef' }}>
    <Button color="secondary" onClick={() => setCreateExpenseModal(false)}>
      Cancel
    </Button>
    <Button color="primary" onClick={handleCreateExpenseSubmit} style={{ backgroundColor: '#0e226a' }}>
      {createExpenseEditMode ? 'Update' : 'Add'} Expense
    </Button>
  </ModalFooter>
</Modal>

{/* Delete Expense Confirmation Modal for Create CI */}
<Modal isOpen={createExpenseDeleteModal} toggle={() => setCreateExpenseDeleteModal(false)} centered>
  <ModalHeader 
    toggle={() => setCreateExpenseDeleteModal(false)} 
    style={{ backgroundColor: '#dc3545', color: 'white' }}
  >
    Confirm Deletion
  </ModalHeader>
  <ModalBody>
    <p>Are you sure you want to delete this expense?</p>
    {selectedCreateExpenseForDelete && (
      <div>
        <p><strong>Description:</strong> {selectedCreateExpenseForDelete.ExpDesc || 'N/A'}</p>
        <p><strong>Estimated Cost:</strong> ${selectedCreateExpenseForDelete.EstimatedCost?.toFixed(2) || '0.00'}</p>
        <p><strong>Actual Expense:</strong> ${selectedCreateExpenseForDelete.Expense?.toFixed(2) || '0.00'}</p>
      </div>
    )}
    <div className="alert alert-warning mt-3">
      <i className="fa fa-exclamation-triangle mr-2"></i>
      This action cannot be undone.
    </div>
  </ModalBody>
  <ModalFooter>
    <Button color="secondary" onClick={() => setCreateExpenseDeleteModal(false)}>
      Cancel
    </Button>
    <Button color="danger" onClick={handleConfirmDeleteCreateExpense}>
      Delete
    </Button>
  </ModalFooter>
</Modal>
    </div>
  );
}
